import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class Player extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "apiId", Model.attribute('apiId'));
    _defineProperty(this, "photoUrl", Model.attribute('photoUrl'));
    _defineProperty(this, "isActive", Model.attribute('isActive'));
    _defineProperty(this, "aliases", Model.attribute('aliases'));
    _defineProperty(this, "number", Model.attribute('number'));
    _defineProperty(this, "entityType", Model.attribute('entityType'));
    _defineProperty(this, "position", Model.attribute('position'));
    _defineProperty(this, "birthDate", Model.attribute('birthDate'));
    _defineProperty(this, "birthPlace", Model.attribute('birthPlace'));
    _defineProperty(this, "height", Model.attribute('height'));
    _defineProperty(this, "weight", Model.attribute('weight'));
    _defineProperty(this, "teams", Model.hasMany('teams'));
  }
  apiEndpoint() {
    return '/nagusi/match-ratings/players' + (this.exists ? '/' + this.data.id : '');
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/Player', Player);